<template>
  <el-dialog
    title="添加拼团设置"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form
      :model="addGroupBuySettingInfo"
      :rules="rules"
      ref="addForm"
      label-width="120px"
    >
      <el-form-item label="拼团名称" prop="groupBuyName">
        <el-input
          v-model="addGroupBuySettingInfo.groupBuyName"
          placeholder="必填，请填写拼团名称"
        />
      </el-form-item>
      <el-form-item label="拼团简介" prop="groupBuyDesc">
        <el-input
          type="textarea"
          v-model="addGroupBuySettingInfo.groupBuyDesc"
          placeholder="必填，请填写拼团简介"
        />
      </el-form-item>
      <el-form-item label="拼团时效" prop="validHours">
        <el-input
          v-model="addGroupBuySettingInfo.validHours"
          placeholder="必填，请填写拼团时效"
        />
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker
          v-model="addGroupBuySettingInfo.startTime"
          type="datetime"
          placeholder="选择开始时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-date-picker
          v-model="addGroupBuySettingInfo.endTime"
          type="datetime"
          placeholder="选择结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveGroupBuySettingInfo">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveGroupBuySetting } from '@/api/goods/groupBuySettingApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddGroupBuySetting',
  data() {
    return {
      dialogVisible: false,
      addGroupBuySettingInfo: {
        groupBuyName: '',
        groupBuyDesc: '',
        validHours: '',
        startTime: '',
        endTime: ''
      },
      rules: {
        groupBuyName: [
          { required: true, message: '拼团名称不能为空', trigger: 'blur' },
          { max: 256, message: '拼团名称不能超过256位', trigger: 'blur' }
        ],
        groupBuyDesc: [
          { required: true, message: '拼团简介不能为空', trigger: 'blur' },
          { max: 500, message: '拼团简介不能超过500位', trigger: 'blur' }
        ],
        validHours: [
          { required: true, message: '拼团时效不能为空', trigger: 'blur' },
          { pattern: /^\d+$/, message: '拼团时效必须为数字', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.addForm.resetFields()
    },
    saveGroupBuySettingInfo() {
      this.$refs.addForm.validate(async valid => {
        if (!valid) return
        
        try {
          const params = {
            ...this.addGroupBuySettingInfo,
            shopId: getShopId()
          }
          await saveGroupBuySetting(params)
          this.$message.success('添加成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          console.error('添加拼团设置失败:', error)
        }
      })
    }
  }
}
</script>